<template>
  <v-sheet>
    Rider Tales
  </v-sheet>
</template>
<script>
export default {
  name: 'RiderTales',
  data: () => ({
    //
  }),
  created() {
    
  }
}
</script>